import axios, {AxiosError, AxiosResponse} from 'axios';
import {Observable, Observer} from 'rxjs';
import IOffer from '../models/Offer';

export default class ApiService {
  public APIURL: string = process.env.API || '';

  public getCatalog(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      axios
        .get(this.APIURL + 'catalog')
        .then((response: AxiosResponse<any>) => {
          if (response && response.data) {
            observer.next(response.data);
          }
          observer.complete();
        })
        .catch((error: AxiosError) => {
          observer.error(error);
        });
    });
  }

  public getPrice(offer: IOffer): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      const body = this.preprocessOffer(offer);
      axios
        .post(this.APIURL + 'price', body)
        .then((response: AxiosResponse<any>) => {
          if (response && response.data) {
            observer.next(response.data);
          }
          observer.complete();
        })
        .catch((error: AxiosError) => {
          observer.error(error);
        });
    });
  }

  public getOffer(offerId: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      axios
        .get(this.APIURL + 'offer/' + offerId)
        .then((response: AxiosResponse<any>) => {
          observer.next(response.data);
          observer.complete();
        })
        .catch((error: AxiosError) => {
          observer.error(error);
        });
    });
  }

  public getOffers(offerId: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      axios
        .get(this.APIURL + 'offers/' + offerId)
        .then((response: AxiosResponse<any>) => {
          observer.next(response.data);
          observer.complete();
        })
        .catch((error: AxiosError) => {
          observer.error(error);
        });
    });
  }

  public saveOffer(offer: IOffer, useForce?: boolean): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      const body = this.preprocessOffer(offer);
      if (offer.token) {
        axios
          .put(this.APIURL + 'offer/' + offer.token + (useForce ? '?updateCatalog=true' : ''), body)
          .then((response: AxiosResponse<any>) => {
            observer.next(response.data);
            observer.complete();
          })
          .catch((error: AxiosError) => {
            observer.error(error);
          });
      } else {
        axios
          .post(this.APIURL + 'offer', body)
          .then((response: AxiosResponse<any>) => {
            if (response && response.data) {
              observer.next(response.data);
            }
            observer.complete();
          })
          .catch((error: AxiosError) => {
            observer.error(error);
          });
      }
    });
  }

  public deleteOffer(offerToken?: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      if (offerToken) {
        axios
          .delete(this.APIURL + 'offer/' + offerToken)
          .then((response: AxiosResponse<any>) => {
            observer.next(response);
            observer.complete();
          })
          .catch((error: AxiosError) => {
            observer.error(error);
          });
      } else {
        observer.error('NoToken');
      }
    });
  }

  public getTranslation(langCode: string) {
    return Observable.create((observer: Observer<any>) => {
      axios
        .get(this.APIURL + 'translation?language=' + langCode)
        .then((response: AxiosResponse<any>) => {
          if (response && response.data) {
            observer.next(response.data);
          }
          observer.complete();
        })
        .catch((error: AxiosError) => {
          observer.error(error);
        });
    });
  }

  public sendEmail(offerToken: string, langCode?: string, isEmbed?: boolean) {
    return Observable.create((observer: Observer<any>) => {
      if (offerToken) {
        axios
          .post(this.APIURL + 'offers/' + offerToken + '/email' + (langCode ? '?language=' + langCode : '') + (isEmbed ? '&isEmbed=true' : '&isEmbed=false'))
          .then((response: AxiosResponse<any>) => {
            observer.next({});
            observer.complete();
          })
          .catch((error: AxiosError) => {
            observer.error(error);
          });
      } else {
        observer.error({message: 'Invalid token'});
      }
    });
  }

  private preprocessOffer(offer: IOffer) {
    // Only use selected extras without modifying original offer selections
    const body = Object.assign({}, offer);
    const selection = Object.assign({}, body.selection);
    selection.extraServices = offer.selection.extraServices.filter((s: any) => s.selected !== false);
    body.selection = selection;
    return body;
  }
}
